import { Box, Button, makeStyles } from "@material-ui/core"
import { PostAdd, Send } from "@material-ui/icons"
import { useHistory } from "react-router-dom"

const useStyles = makeStyles(theme => ({
    nav: {
        maxWidth: 720,
        margin: "0 auto",
        marginBottom: theme.spacing(2),
        display: "flex",
        gap: theme.spacing(2),
        flexWrap: "wrap",
    },
    botao: {
        flex: 1,
        minWidth: 160,
    },
}))

/**
 * @param {{ ativo: "envio" | "criar" }} props
 */
export default function TemplateWhatsappNav({ ativo }) {
    const classes = useStyles()
    const history = useHistory()

    return (
        <Box className={classes.nav}>
            <Button
                className={classes.botao}
                variant={ativo === "envio" ? "contained" : "outlined"}
                color="primary"
                startIcon={<Send />}
                onClick={() => history.push("/servicos/modulo/envio-template-whatsapp-grupo")}
            >
                Envio template
            </Button>
            <Button
                className={classes.botao}
                variant={ativo === "criar" ? "contained" : "outlined"}
                color="primary"
                startIcon={<PostAdd />}
                onClick={() => history.push("/servicos/modulo/criar-template-whatsapp")}
            >
                Criar template
            </Button>
        </Box>
    )
}
